import { render, staticRenderFns } from "./OrbitTokenNotWhitelistedStep.vue?vue&type=template&id=10055a05"
import script from "./OrbitTokenNotWhitelistedStep.vue?vue&type=script&lang=ts"
export * from "./OrbitTokenNotWhitelistedStep.vue?vue&type=script&lang=ts"
import style0 from "./OrbitTokenNotWhitelistedStep.vue?vue&type=style&index=0&id=10055a05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports